import { CacheHandler } from 'reusable/utils/cache'
import { ThemeMode } from 'theme/ThemeStore'

export default new CacheHandler<ThemeMode>({ key: 'GapAppLocalThemeMode', cacheLocation: 'localStorage' })
